module.exports = __webpack_public_path__ + "static/media/app-download-qr.10187710.png";